module.exports = __webpack_public_path__ + "img/HeroTypesQuiz-Q4.4bae4dde.png";